import $ from 'jquery';

// À noter que ça marche seulement en https.
// Pour faire marcher en local, il faut enabler le chrome flags "Insecure origins treated as secure"
$('body').on('click', '.js-clipboard-copy', (event) => {
    const $copyButton = $(event.currentTarget);
    const $copyInput = $(event.currentTarget).closest('.js-clipboard-copy-wrapper').find('input');
    if (navigator.clipboard) {
        let textToCopy = '';
        if ($copyInput.length) { // Version avec un input
            textToCopy = $copyInput.val();
        } else { // Version sans champ input
            textToCopy = $copyButton.find('.class-code').text();
        }
        const $confirmationMsg = $copyButton.find('.copied-confirmation');
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                if ($confirmationMsg) {
                    $confirmationMsg.addClass('msg-fade-out');
                    setTimeout(() => {
                        $confirmationMsg.removeClass('msg-fade-out');
                    }, 4000);
                }
            })
            .catch((err) => {
                window.console.error('Error copying text to clipboard: ', err);
            });
    } else {
        // If the Asynchronous Clipboard API is not supported, display a message
        window.console.warn('Asynchronous Clipboard API is not supported in this browser.');
    }
});
